/** Base class for every error the domain raises deliberately. */
export class DomainError extends Error {
    constructor(message) {
        super(message);
        this.name = new.target.name;
    }
}
/** Two Money values of different assets were combined. */
export class AssetMismatchError extends DomainError {
    left;
    right;
    constructor(left, right) {
        super(`Cannot combine ${left} with ${right}`);
        this.left = left;
        this.right = right;
    }
}
/** A quantity, price or fee was outside the range the domain allows. */
export class InvalidAmountError extends DomainError {
}
//# sourceMappingURL=errors.js.map